/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

const CHART_TREND_PATH =
  'M12.6667 18.6666C12.9319 18.6666 13.1862 18.5612 13.3738 18.3737C13.5613 18.1862 13.6667 17.9318 13.6667 17.6666C13.6699 17.6333 13.6699 17.5998 13.6667 17.5666L15.5267 15.7066H15.68H15.8333L16.9067 16.7799C16.9067 16.7799 16.9067 16.8133 16.9067 16.8333C16.9067 17.0985 17.012 17.3528 17.1996 17.5404C17.3871 17.7279 17.6414 17.8333 17.9067 17.8333C18.1719 17.8333 18.4262 17.7279 18.6138 17.5404C18.8013 17.3528 18.9067 17.0985 18.9067 16.8333V16.7799L21.3333 14.3333C21.5311 14.3333 21.7245 14.2746 21.8889 14.1647C22.0534 14.0548 22.1815 13.8987 22.2572 13.7159C22.3329 13.5332 22.3527 13.3321 22.3141 13.1382C22.2755 12.9442 22.1803 12.766 22.0404 12.6261C21.9006 12.4863 21.7224 12.3911 21.5284 12.3525C21.3344 12.3139 21.1334 12.3337 20.9506 12.4094C20.7679 12.4851 20.6117 12.6132 20.5019 12.7777C20.392 12.9421 20.3333 13.1355 20.3333 13.3333C20.3301 13.3665 20.3301 13.4 20.3333 13.4333L17.9267 15.8399H17.82L16.6667 14.6666C16.6667 14.4014 16.5613 14.147 16.3738 13.9595C16.1862 13.7719 15.9319 13.6666 15.6667 13.6666C15.4014 13.6666 15.1471 13.7719 14.9596 13.9595C14.772 14.147 14.6667 14.4014 14.6667 14.6666L12.6667 16.6666C12.4014 16.6666 12.1471 16.7719 11.9596 16.9595C11.772 17.147 11.6667 17.4014 11.6667 17.6666C11.6667 17.9318 11.772 18.1862 11.9596 18.3737C12.1471 18.5612 12.4014 18.6666 12.6667 18.6666V18.6666ZM21.6667 21.3333H10.3333V9.99992C10.3333 9.82311 10.2631 9.65354 10.1381 9.52851C10.013 9.40349 9.84348 9.33325 9.66667 9.33325C9.48986 9.33325 9.32029 9.40349 9.19526 9.52851C9.07024 9.65354 9 9.82311 9 9.99992V21.9999C9 22.1767 9.07024 22.3463 9.19526 22.4713C9.32029 22.5963 9.48986 22.6666 9.66667 22.6666H21.6667C21.8435 22.6666 22.013 22.5963 22.1381 22.4713C22.2631 22.3463 22.3333 22.1767 22.3333 21.9999C22.3333 21.8231 22.2631 21.6535 22.1381 21.5285C22.013 21.4035 21.8435 21.3333 21.6667 21.3333Z';

const iconPropTypes = {
  size: PropTypes.number,
  fill: PropTypes.string,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/** Figma tile catalog icon — colored tile with white trend chart (32×32). */
const TileLibraryTrendIcon = ({
  size = 32,
  fill = '#1B963B',
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['ds-icon', className].filter(Boolean).join(' ')}
    aria-hidden={ariaLabel ? undefined : ariaHidden}
    aria-label={ariaLabel || undefined}
    role={ariaLabel ? 'img' : undefined}
    focusable="false"
    {...props}
  >
    <rect width="32" height="32" rx="4" fill={fill} />
    <path d={CHART_TREND_PATH} fill="white" />
  </svg>
);

TileLibraryTrendIcon.propTypes = iconPropTypes;

export default TileLibraryTrendIcon;
